"use strict";

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsNodeReturnNonParcelNodeError = exports.ChangeRequestNoPrevDataError = exports.ReducerInvalidStepError = exports.ReducerInvalidActionError = exports.ParcelTypeMethodMismatch = exports.ReadOnlyError = void 0;

var ReadOnlyError = function ReadOnlyError() {
  return new Error("This property is read-only");
};

exports.ReadOnlyError = ReadOnlyError;

var ParcelTypeMethodMismatch = function ParcelTypeMethodMismatch(key, parcelType, path) {
  var suffix = Array.isArray(path) ? "(keyPath: [".concat(path.join(', '), "]).") : "";
  return new Error(".".concat(key, "() is not a function. It can only be called on parcels of type \"").concat(parcelType, "\". ").concat(suffix));
};

exports.ParcelTypeMethodMismatch = ParcelTypeMethodMismatch;

var ReducerInvalidActionError = function ReducerInvalidActionError(actionType) {
  return new Error("\"".concat(actionType, "\" is not a valid action"));
};

exports.ReducerInvalidActionError = ReducerInvalidActionError;

var ReducerInvalidStepError = function ReducerInvalidStepError(stepType) {
  return new Error("\"".concat(stepType, "\" is not a valid action step type"));
};

exports.ReducerInvalidStepError = ReducerInvalidStepError;

var ChangeRequestNoPrevDataError = function ChangeRequestNoPrevDataError() {
  return new Error("ChangeRequest data cannot be accessed before setting changeRequest.prevData");
};

exports.ChangeRequestNoPrevDataError = ChangeRequestNoPrevDataError;

var AsNodeReturnNonParcelNodeError = function AsNodeReturnNonParcelNodeError() {
  return new Error("The return value of an asNode() updater must be a ParcelNode");
};

exports.AsNodeReturnNonParcelNodeError = AsNodeReturnNonParcelNodeError;